import { render, staticRenderFns } from "./SmsConversation.vue?vue&type=template&id=664a5f7a&"
import script from "./SmsConversation.vue?vue&type=script&lang=js&"
export * from "./SmsConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports